import { ActionIcon, CopyButton, Group, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { brand } from '@/theme/theme';
import { gcsConsoleUrl } from './gcsConsoleUrl';

/** `full` shows the whole uri, wrapping; the table default keeps the tail on one line. */
export function UriCell({ uri, full = false }: { uri?: string | null; full?: boolean }) {
  const { t } = useTranslation();
  if (!uri) return <Text c={brand.textMuted}>—</Text>;
  const short = !full && uri.length > 42 ? '…' + uri.slice(-40) : uri;
  const console = gcsConsoleUrl(uri);
  return (
    <Group gap={4} wrap="nowrap" align="flex-start">
      <Text ff="monospace" fz={11} title={uri} style={full ? { wordBreak: 'break-all' } : { whiteSpace: 'nowrap' }}>
        {short}
      </Text>
      <CopyButton value={uri}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? '✓' : 'copy'}>
            <ActionIcon size="xs" variant="subtle" color="forest" onClick={copy} aria-label="copy">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="9" y="9" width="12" height="12" rx="2" />
                <path d="M5 15V5a2 2 0 0 1 2-2h10" />
              </svg>
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
      {console && (
        <Tooltip label={t('common.openInGcs')}>
          <ActionIcon
            component="a"
            href={console}
            target="_blank"
            rel="noopener"
            size="xs"
            variant="subtle"
            color="forest"
            aria-label={t('common.openInGcs')}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M14 4h6v6" />
              <path d="M20 4 10 14" />
              <path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" />
            </svg>
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  );
}
